import type {
  PostMeasureSoleRequest,
  PostMeasureSoleResponse,
  PatchMeasureSoleRequest,
  PatchMeasureSoleResponse,
  GetMeasureSoleRequest,
  GetMeasureSoleResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getMeasureSole = sendRequest<GetMeasureSoleRequest, GetMeasureSoleResponse>({
  url: '/measure_sole',
  method: 'get',
});

export const patchMeasureSole = sendRequest<PatchMeasureSoleRequest, PatchMeasureSoleResponse>({
  url: '/measure_sole',
  method: 'patch',
});

export const postMeasureSole = sendRequest<PostMeasureSoleRequest, PostMeasureSoleResponse>({
  url: '/measure_sole',
  method: 'post',
});
